export default __webpack_public_path__ + "static/media/bearerOfFruit3.dd479b10.png";